 $( document ).ready(function() {
  $(document).on("click", "#edit_active", function(){
    $("#show").hide();
  });
});